import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const testimonials = [
  {
    id: 'test-001',
    name: 'Thabo Nkosi',
    location: 'PMB, KZN',
    rating: 5,
    text: 'Absolutely love this course. The online booking made everything so easy — I had my tee time confirmed within minutes. The course itself is immaculate and the staff are incredibly welcoming.',
    rounds: 22,
    highlight: true,
  },
  {
    id: 'test-002',
    name: 'Priya Govender',
    location: 'PMB, KZN',
    rating: 5,
    text: 'Warm and welcoming atmosphere. As a mid-handicapper I really appreciate how playable the course is. The loyalty programme is a brilliant touch.',
    rounds: 18,
    highlight: false,
  },
  {
    id: 'test-003',
    name: 'Hendrik van der Berg',
    location: 'Kloof, KZN',
    rating: 5,
    text: 'Driven up from Kloof multiple times — well worth it. The stream holes on the back nine are a real treat. Senior rates are very fair.',
    rounds: 15,
    highlight: false,
  },
  {
    id: 'test-004',
    name: 'Zanele Dlamini',
    location: 'Durban, KZN',
    rating: 5,
    text: 'First time visiting and it won\'t be my last. Flat terrain made it accessible and the clubhouse is a great spot to wind down after a round.',
    rounds: 4,
    highlight: false,
  },
];

export default function TestimonialsSection() {
  const featured = testimonials[0];
  const rest = testimonials.slice(1);

  return (
    <section className="py-20 bg-card">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="text-accent font-semibold text-sm tracking-widest uppercase">Visitor Reviews</span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-2">What Golfers Say</h2>
            <p className="text-muted-foreground mt-2 text-base max-w-md">
              Real rounds, real feedback — from visitors just like you.
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 })?.map((_, i) => (
                <Icon key={`overall-star-${i}`} name="StarIcon" size={18} variant="solid" className="text-accent" />
              ))}
            </div>
            <span className="text-foreground font-bold text-lg">4.9</span>
            <span className="text-muted-foreground text-sm">overall rating</span>
          </div>
        </div>

        {/* Asymmetric bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {/* Featured large card — spans 2 rows on lg */}
          <div className="lg:row-span-2 card-hover bg-background border-2 border-primary/20 rounded-2xl p-7 flex flex-col">
            <div className="flex gap-0.5 mb-4">
              {Array.from({ length: featured?.rating })?.map((_, i) => (
                <Icon key={`star-${featured?.id}-${i}`} name="StarIcon" size={16} variant="solid" className="text-accent" />
              ))}
            </div>
            <p className="text-foreground text-base leading-relaxed mb-6 italic flex-1">
              &ldquo;{featured?.text}&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-5 border-t border-border">
              <div className="w-11 h-11 rounded-full gradient-primary flex items-center justify-center text-white font-bold text-base shrink-0">
                {featured?.name?.charAt(0)}
              </div>
              <div>
                <div className="text-foreground font-semibold text-sm">{featured?.name}</div>
                <div className="text-muted-foreground text-xs">{featured?.location} · {featured?.rounds} rounds played</div>
              </div>
            </div>
          </div>

          {/* Remaining cards */}
          {rest?.map((t) => (
            <div key={t?.id} className="card-hover bg-background border border-border rounded-2xl p-6 flex flex-col">
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t?.rating })?.map((_, i) => (
                  <Icon key={`star-${t?.id}-${i}`} name="StarIcon" size={14} variant="solid" className="text-accent" />
                ))}
              </div>
              <p className="text-foreground text-sm leading-relaxed mb-4 italic flex-1">&ldquo;{t?.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-border">
                <div className="w-9 h-9 rounded-full gradient-primary flex items-center justify-center text-white font-bold text-sm shrink-0">
                  {t?.name?.charAt(0)}
                </div>
                <div>
                  <div className="text-foreground font-semibold text-sm">{t?.name}</div>
                  <div className="text-muted-foreground text-xs">{t?.location} · {t?.rounds} rounds played</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Conversion nudge */}
        <div className="text-center">
          <p className="text-muted-foreground text-sm mb-4">Ready to experience it yourself?</p>
          <Link
            href="/online-booking"
            className="btn-gold px-8 py-3.5 rounded-xl text-base font-bold inline-flex items-center gap-2"
          >
            <Icon name="CalendarDaysIcon" size={18} variant="outline" />
            Book Your Round Today
          </Link>
        </div>
      </div>
    </section>
  );
}